//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'weChatNews',
    data() {
        return {
            loading: false,
            list: [],
            totalCount: 0,
            pageSize: 20,
            currentPage: 1,
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '业务类型',
                    align: 'center',
                    key: 'businessTypeStr'
                },
                {
                    title: '项目名称',
                    align: 'center',
                    key: 'projectName'
                },
                {
                    title: '操作人',
                    align: 'center',
                    key: 'operator'
                },
                {
                    title: '接收人',
                    align: 'center',
                    key: 'receiver'
                },
                {
                    title: '接收人OpenId',
                    align: 'center',
                    key: 'openId'
                },
                {
                    title: '发送状态',
                    align: 'center',
                    key: 'statusStr'
                },
                {
                    title: '发送时间',
                    align: 'center',
                    key: 'sendDateStr'
                },
                {
                    title: '发送结果',
                    align: 'center',
                    key: 'sendResponseMessage'
                }
            ],
            searchInput: {}
        };
    },
    methods: {
        pageChange(page) {
            // this.$store.commit('city/setCurrentPage', page);
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            // this.$store.commit('city/setPageSize', pagesize);
            this.pageSize = pagesize;
            this.getPage();
        },
        async getPage() {
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.loading = true;
            await abp.ajax.post('/api/services/app/WeChatRecord/SearchRecordList', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    created() {
        this.getPage();
    }
};
